import { getJSON } from 'bv-fetch';

const fetchSections = () => getJSON('/api/site_navigation/top_navigation');

export default fetchSections;
